import type { ExploraHistoryEntry, ExploraVariable } from '../../core/types/payloads/explora.types';
import type { SandboxPricePoint } from '../../core/types/payloads/sandbox.types';

export interface ChartPoint {
  label: string;
  value: number;
}

function applyExploraStep(current: number, variable: ExploraVariable): number {
  if (variable.type === 'MULTIPLY') {
    return Math.round(current * variable.internalValue);
  }
  return current + variable.internalValue;
}

/** Serie de precios a partir del historial de acciones Explora. */
export function buildExploraPriceSeries(
  initialValue: number,
  history: ExploraHistoryEntry[],
  variables: ExploraVariable[],
): ChartPoint[] {
  const points: ChartPoint[] = [{ label: 'Inicio', value: initialValue }];
  let current = initialValue;
  for (const entry of history) {
    const variable = variables.find((v) => v.id === entry.variableId);
    if (variable) {
      current = applyExploraStep(current, variable);
    }
    points.push({ label: entry.variableLabel, value: current });
  }
  return points;
}

/** Serie de precios para mercado inflacionario. */
export function buildInflationPriceSeries(
  basePrice: number,
  history: SandboxPricePoint[],
): ChartPoint[] {
  const points: ChartPoint[] = [{ label: 'Base', value: basePrice }];
  for (const entry of history) {
    points.push({ label: entry.modifierId, value: entry.price });
  }
  return points;
}

export function formatExploraCurrency(value: number, unitLabel?: string, symbol = '$'): string {
  const formatted = String(Math.round(value));
  if (unitLabel === '%' || unitLabel?.includes('%')) {
    return `${formatted}${unitLabel || '%'}`;
  }
  if (value >= 1000) {
    return `${symbol}${formatted}`;
  }
  return `${formatted}${unitLabel ? ` ${unitLabel}` : ''}`;
}
